import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TankService } from 'src/app/services/tank.service';
import { UserService } from 'src/app/services/user.service';
import { User } from 'src/app/shared/models/User';

@Component({
  selector: 'app-user-page',
  templateUrl: './user-page.component.html',
  styleUrls: ['./user-page.component.css']
})
export class UserPageComponent implements OnInit {
  userForm: FormGroup;
  tankName: string;
  tankId: number;
  titulo = 'Crear Usuario para: ';
  id: number;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private _tankService: TankService
  ) {
    this.userForm = this.initUserForm();
    this.id = parseInt(this.activatedRoute.snapshot.paramMap.get('id'), 10);
  }

  ngOnInit() {
    this._tankService.getCurrentTank().subscribe((tank) => {
      console.log("tanque ", tank);
      this.tankName = tank.name;
      this.tankId = tank.id;
      this.initializeEditMode();
    });
  }

  saveUser() {
    if (this.userForm.invalid) {
      return;
    }

    const user: User = this.userForm.value;

    if (this.tankId && user.tanks.indexOf(this.tankId) === -1) {
      user.tanks = [this.tankId];
    }

    const saveOrUpdate = this.id
      ? this.userService.editUser(this.id, user)
      : this.userService.saveUser(user);

    saveOrUpdate.subscribe(
      () => this.router.navigate(['/users']),
      (error) => {
        console.log(error);
        if (error && error.error && error.error.message) {
          // Muestra una alerta con el mensaje de error
          alert('Error al guardar el usuario:\n' + error.error.message);
        } else {
          // Si no se puede acceder al mensaje de error, muestra un mensaje genérico
          alert('Error al guardar el usuario: Error desconocido.');
        }

        this.router.navigate(['/users']);
      }
    );
  }

  private initUserForm(): FormGroup {
    return this.fb.group({
      id: [''],
      token: [''],
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      name: ['', Validators.required],
      operatorCode: ['', Validators.minLength(5)],
      lastname: ['', Validators.required],
      businessName: [''],
      cuitName: [''],
      address: [''],
      enabled: [false],
      role: ['', Validators.required],
      isCharger: [false],
      phoneNumber: [''],
      tanks: [''],
      tankId: ['']
    });
  }

  private initializeEditMode() {
    if (this.id) {
      this.titulo = 'Editar Usuario';
      this.userService.getUserByTankAndId(this.tankId, this.id).subscribe((data) => {
        this.userForm.patchValue(data[0]);
      });
    }
  }

}
